import { Injectable } from '@angular/core';
import { StatusCategoryEnum } from '@shared/constants/site_status_category.enum';
import { SiteStatus } from '@shared/models/site-status';
import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class SiteStatusService {
  apiUrl = environment.apiUrl + '/sites/';
  public allCategoryValues = [];
  public siteStatusList: SiteStatus[] = [];

  public sitePendingStatusList = [];
  public siteSubmittedStatusList = [];
  public siteApprovedStatusList = [];
  public siteUnderReviewStatusList = [];
  public siteActiveStatusList = [];
  public siteInactiveStatusList = [];
  public loaded: boolean = false;
  
  constructor(readonly http: HttpClient) {
  }

  load(): Observable<void> {
    return this.http.get<SiteStatus[]>(`${this.apiUrl}site_statuses/`, { headers: new HttpHeaders().set('X-FC-Noauth', 'true') })
      .pipe(
        tap((siteStatuses: SiteStatus[]) => {
          this.allCategoryValues = Object.values(StatusCategoryEnum);
          this.siteStatusList = [...siteStatuses].sort((a, b) => a.name.localeCompare(b.name));
          // filter by status bucket
          this.sitePendingStatusList = siteStatuses
            .filter(status => status.category == StatusCategoryEnum.PENDING)
            .map(status => status.name)
            .sort();
          this.siteApprovedStatusList = siteStatuses
            .filter(status => status.category == StatusCategoryEnum.APPROVED)
            .map(status => status.name)
            .sort();
          this.siteUnderReviewStatusList = siteStatuses
            .filter(status => status.category == StatusCategoryEnum.REVIEW)
            .map(status => status.name)
            .sort();
          this.siteSubmittedStatusList = [...this.siteApprovedStatusList, ...this.siteUnderReviewStatusList].sort();
          this.siteActiveStatusList = siteStatuses
            .filter(status => status.category == StatusCategoryEnum.ACTIVE)
            .map(status => status.name)
            .sort();
          this.siteInactiveStatusList = siteStatuses
            .filter(status => status.category == StatusCategoryEnum.INACTIVE)
            .map(status => status.name)
            .sort();
          this.loaded = true;
        }),
        map(() => void 0)
      );
  }

  public getStatusByCategory(category: string): SiteStatus[] {
    return this.siteStatusList.filter(s => s.category === category);
  }

}
